import React from 'react';
import PropTypes from 'prop-types';

import GroupVisits, { visitGroupType } from './GroupVisits';
import { HeadingLabel, HeadingPara } from '../../design-system/Headings';
import Container from '../../design-system/Containers';
import PageSection from '../../design-system/PageSection';
import phrasesType from '../../proptypes/phrases';
import formType from '../../proptypes/forms';
import { LinkButton } from '../../design-system/Buttons';

const selectFormattedVisitDate = (visitDate) => {
  const date = new Date(visitDate);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };

  return date.toLocaleString('en-US', options).toLocaleUpperCase();
};

export default function GroupVisitSection({
  group,
  title,
  onUnlockProfileClick,
  onDownloadDossierClick,
  showPremiumOptions,
  phrases,
  unlockAllProfilesPath,
  profileInviteForm,
}) {
  return group?.members?.length ? (
    <PageSection center bgGradUp pyXl pxXs borderT container={false}>
      <Container center css={{ maxWidth: '690px' }}>
        <HeadingPara el="h2" py0 my0>
          {title}
        </HeadingPara>
        <HeadingLabel py0>
          {selectFormattedVisitDate(group.visitDate)}
        </HeadingLabel>
        <GroupVisits
          group={group.members}
          phrases={phrases}
          onUnlockProfileClick={onUnlockProfileClick}
          onDownloadDossierClick={onDownloadDossierClick}
          showPremiumOptions={showPremiumOptions}
          profileInviteForm={profileInviteForm}
        />
      </Container>
      {unlockAllProfilesPath && (
        <Container center>
          <LinkButton
            href={unlockAllProfilesPath}
            className="ss_d--flex ss_row"
          >
            {phrases.groupVisitor.unlockAllProfilesButtonLabel}
            <img
              alt=""
              src="//images.ctfassets.net/gtqjh9j40j4m/4WO5NCipv57JHayFBCOaNB/fea23a35647236e4c4633e4a787d021b/profile-lock.svg"
              style={{
                alignSelf: 'center',
                filter: 'brightness(0)',
                height: '24px',
                paddingLeft: '8px',
                width: '32px',
              }}
            />
          </LinkButton>
        </Container>
      )}
    </PageSection>
  ) : null;
}

GroupVisitSection.defaultProps = {
  group: null,
  unlockAllProfilesPath: null,
};

GroupVisitSection.propTypes = {
  group: PropTypes.exact({
    members: visitGroupType,
    visitDate: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  onUnlockProfileClick: PropTypes.func.isRequired,
  onDownloadDossierClick: PropTypes.func.isRequired,
  showPremiumOptions: PropTypes.bool.isRequired,
  phrases: phrasesType.isRequired,
  unlockAllProfilesPath: PropTypes.string,
  profileInviteForm: formType.isRequired,
};
